import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Effet de bord au plus tôt : capture `?s=` et nettoie l'URL (avant render).
import "./engine/source";
import "./styles/tokens.css";
import "./styles/cockpit.css";
import { App } from "./App";
import { DilemmaPage } from "./components/DilemmaPage";
import { StatsDashboard } from "./components/StatsDashboard";

const root = document.getElementById("root");
if (!root) throw new Error("Élément #root introuvable dans index.html");

/**
 * Routing path-based vanille au niveau ReactDOM root.
 * - `/jour*`  → Le Dilemme du jour (pas de WASM, fetch léger)
 * - `/stats*` → Backoffice de statistiques (login opérateur)
 * - sinon     → Cockpit complet (mandat 5 ans)
 *
 * Le check se fait une seule fois au mount — la navigation vers
 * une autre route passe par un `<a href>` qui recharge la page.
 */
const path = window.location.pathname;
const page = path.startsWith("/jour") ? (
  <DilemmaPage />
) : path.startsWith("/stats") ? (
  <StatsDashboard />
) : (
  <App />
);

createRoot(root).render(<StrictMode>{page}</StrictMode>);
